// ======================================================================
// File Name       : course
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const COURSE_RECEIVE_SEARCH_CONDITION = 'COURSE_RECEIVE_SEARCH_CONDITION';
export const COURSE_RECEIVE_USER_SEARCH_RESUTL = 'COURSE_RECEIVE_USER_SEARCH_RESUTL';
export const COURSE_RECEIVE_USER_LIST = 'COURSE_RECEIVE_USER_LIST';
export const COURSE_INPUT_CHANGE = 'COURSE_INPUT_CHANGE';
export const COURSE_RECEIVE_COURSE_LIST = 'COURSE_RECEIVE_COURSE_LIST';
export const COURSE_RECEIVE_COURSE_RELATION = 'COURSE_RECEIVE_COURSE_RELATION';
export const COURSE_INIT_DATA_FOR_DETAIL_EDIT_CONFIRM_DIALOG = 'COURSE_INIT_DATA_FOR_DETAIL_EDIT_CONFIRM_DIALOG';
export const COURSE_INIT_DATA_FOR_REGISTER_DIALOG = 'COURSE_INIT_DATA_FOR_REGISTER_DIALOG';
export const COURSE_ADD_REMOVE_USER = 'COURSE_ADD_REMOVE_USER';
export const COURSE_ADD_REMOVE_ALL_USER = 'COURSE_ADD_REMOVE_ALL_USER';
export const COURSE_ADD_USER_RELATION = 'COURSE_ADD_USER_RELATION';
export const COURSE_REMOVE_USER_RELATION = 'COURSE_REMOVE_USER_RELATION';
export const COURSE_REMOVE_ALL_USER_RELATION = 'COURSE_REMOVE_ALL_USER_RELATION';
export const COURSE_EDIT_PERIOD_TIME = 'COURSE_EDIT_PERIOD_TIME';
export const COURSE_CHANGE_EDIT_TYPE = 'COURSE_CHANGE_EDIT_TYPE';
export const COURSE_RESET_INIT_DATA = 'COURSE_RESET_INIT_DATA';
export const COURSE_RESET_COURSE_CONDITION = 'COURSE_RESET_COURSE_CONDITION';
export const COURSE_CHANGE_DATA = 'COURSE_CHANGE_DATA';
export const COURSE_GET_THUMBNAIL_DEFAULT = 'COURSE_GET_THUMBNAIL_DEFAULT';
export const GET_USER_COURSE_RELATION = 'GET_USER_COURSE_RELATION';
export const COURSE_ADD_GROUP_RELATION = 'COURSE_ADD_GROUP_RELATION';
export const COURSE_DEL_GROUP_RELATION = 'COURSE_DEL_GROUP_RELATION';
export const COURSE_DEL_ALL_GROUP_RELATION = 'COURSE_DEL_ALL_GROUP_RELATION';
export const COURSE_EDIT_GROUP_PERIOD_TIME = 'COURSE_EDIT_GROUP_PERIOD_TIME';
export const GET_GROUP_COURSE_RELATION = 'GET_GROUP_COURSE_RELATION';
export const GET_DIRECT_GROUP_COURSE_RELATION = 'GET_DIRECT_GROUP_COURSE_RELATION';
export const REMOVED_DIRECT_GROUP_COURSE_RELATION = 'REMOVED_DIRECT_GROUP_COURSE_RELATION';
export const COURSE_SAVE_DETAIL_SETTING_STATE = 'COURSE_SAVE_DETAIL_SETTING_STATE'; // Step 10.2.0
